export enum Countries {
  Argentina = 'AR',
  Colombia = 'CO',
  Mexico = 'MX',
  Brazil = 'BR',
  Chile = 'CL',
  Ecuador = 'EC',
  Uruguay = 'UY',
  Peru = 'PE'
}
